module.exports = "<p>\r\n  group-list works!\r\n</p>\r\n"